import "./pt-electric-bus.css"

import  ENERGIZED_DEENERGIZED from "../../mixins/ENERGIZED_DEENERGIZED"

export default {
    mixins: [ENERGIZED_DEENERGIZED]
}

